import type { FunctionComponent } from 'react';
import { useMemo } from 'react';

import { PillSwitcher } from '../../../shared/components/pill-switcher/pill-switcher';

export const TransactionsMenu: FunctionComponent = () => {
    return (
        <PillSwitcher
            items={useMemo(
                () => [
                    {
                        id: 'deposits',
                        name: 'transactions-menu.deposits.label',
                        href: '/account/transactions/deposits',
                    },
                    {
                        id: 'withdrawals',
                        name: 'transactions-menu.withdrawals.label',
                        href: '/account/transactions/withdrawals',
                    },
                    // {
                    //     id: 'game-play',
                    //     name: 'transactions-menu.game-play.label',
                    //     href: '/account/transactions/game-play',
                    // },
                    {
                        id: 'sports-bets',
                        name: 'transactions-menu.sports-bets.label',
                        href: '/account/transactions/sports-bets',
                    },
                ],
                [],
            )}
        />
    );
};
